import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import axiosInstance from 'src/utils/axios';

export interface LinkInvoiceToReceiptRequest {
  receiptId: string;
  invoiceId: string;
}

interface UseLinkInvoiceToReceiptMutationOptions {
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

const useLinkInvoiceToReceiptMutation = ({
  onSuccess,
  onError,
}: UseLinkInvoiceToReceiptMutationOptions = {}) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async ({ receiptId, invoiceId }: LinkInvoiceToReceiptRequest) => {
      const response = await axiosInstance.put(api.linkInvoice(receiptId, invoiceId));
      return response.data;
    },
    onSuccess: (data) => {
      // Invalidate related queries
      queryClient.invalidateQueries({
        queryKey: queryKeys.receipt.root,
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.invoice.root,
      });
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });

  return mutation;
};

export default useLinkInvoiceToReceiptMutation;
